var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.047 0L29.8652 2.81821L7.22559 24.9881H81.7124V28.9258H7.22559L29.8652 51.1818L27.047 54L2.28882e-05 26.953L27.047 0Z","fill":"#F0DEDE"}));
}

ArrowLeftInline.defaultProps = {"width":"82","height":"54","viewBox":"0 0 82 54","fill":"none"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
